export {
  fetchPosterTemplateList as fetchList,
  createPosterTemplate as create,
  updatePosterTemplate as updateById,
  deletePosterTemplate as deleteById,
  deletePosterTemplateBatch as deleteByIdInBatch,
  importSharePosterTemplates
} from './meihui'
